export class CatalogCharacteristicObject {
    private _namingId: string;
    private _name: string;
    private _type: string;
    private _out: boolean;

    constructor(namingId: string, name: string, type: string, out: boolean) {
        this._namingId = namingId;
        this._name = name;
        this._type = type;
        this._out = out;
    }

    static create(): CatalogCharacteristicObject {
        return new CatalogCharacteristicObject('', '', '', false);
    }

    public get namingId(): string {
        return this._namingId;
    }

    public get name(): string {
        return this._name;
    }

    public get type(): string {
        return this._type;
    }

    public get out(): boolean {
        return this._out;
    }
}
